import React from "react";
import ReactMarkdown from "react-markdown";
import { capitalizeString } from "../../helpers/helpers";

const ChurchMardown = ({ church }) => {
    const markdownContent = `${ church.description && church.parishName && church.municipalityName ? `<div>${church.description} ligger i ${capitalizeString( church.parishName )} i ${church.municipalityName} kommune.</div>` : "" }
  ${ church.mainBuildingMaterial && church.constructionYear ? `<div>Den er bygget i ${church.mainBuildingMaterial} og ble oppført i ${church.constructionYear}.</div>` : "" }
  ${church.planType && church.approvedCapacity ? `<div>Kirken har ${church.planType} og ${church.approvedCapacity} sitteplasser.</div>` : ""}
  ${church.conservationStatus ? `<div>Kirken har vernestatus ${church.conservationStatus}.</div>` : ""}  
  ${church.architect ? `<div>Arkitekt: ${church.architect}</div>` : ""}
`;
    return <ReactMarkdown source={markdownContent} escapeHtml={false} />;
};

export default ChurchMardown;



// WEBPACK FOOTER //
// ./src/components/ChurchMarkdown/index.js